import { defineStore } from 'pinia';
import responsiblesApi from '@/api/responsiblesApi.js';

function keyOf(entityType, id) {
    return `${entityType}:${id}`;
}

export const useResponsiblesStore = defineStore('responsiblesStore', {
    state: () => ({
        // perKey: { [entityKey]: { items: ResponsibilityItem[], primary_user_id, loading, error } }
        perKey: {},
    }),

    getters: {
        // Вернуть "сырые" items для UI
        items: (state) => (entityType, id) => state.perKey[keyOf(entityType, id)]?.items || [],
        primaryUserId: (state) => (entityType, id) => state.perKey[keyOf(entityType, id)]?.primary_user_id ?? null,
        loading: (state) => (entityType, id) => !!state.perKey[keyOf(entityType, id)]?.loading,
        error: (state) => (entityType, id) => state.perKey[keyOf(entityType, id)]?.error || null,
    },

    actions: {
        _ensure(entityType, id) {
            const k = keyOf(entityType, id);
            if (!this.perKey[k]) this.perKey[k] = { items: [], primary_user_id: null, loading: false, error: null };
            return k;
        },

        async loadCurrent(entityType, id) {
            const k = this._ensure(entityType, id);
            this.perKey[k].loading = true;
            this.perKey[k].error = null;
            try {
                const data = await responsiblesApi.getCurrent(entityType, id);
                this.perKey[k].items = Array.isArray(data?.items) ? data.items : [];
                this.perKey[k].primary_user_id = data?.primary_user_id ?? null;
            } catch (e) {
                this.perKey[k].error = e;
                this.perKey[k].items = [];
                this.perKey[k].primary_user_id = null;
            } finally {
                this.perKey[k].loading = false;
            }
        },

        async assign(entityType, id, payload) {
            await responsiblesApi.assign(entityType, id, payload);
            await this.loadCurrent(entityType, id);
        },

        async unassign(entityType, id, payload) {
            await responsiblesApi.unassign(entityType, id, payload);
            await this.loadCurrent(entityType, id);
        },

        async makePrimary(entityType, id, payload) {
            await responsiblesApi.makePrimary(entityType, id, payload);
            await this.loadCurrent(entityType, id);
        },

        async reorder(entityType, id, payload) {
            await responsiblesApi.reorder(entityType, id, payload);
            await this.loadCurrent(entityType, id);
        },
    },
});